import StyledPromptSuggestionList from '../../styles/StyledPromptSuggestionList';
import PromptSuggestionListItem from '../PromptSuggestionListItem/PromptSuggestionListItem';

interface PromptSuggestionListProps {
  items: string[];
}

const PromptSuggestionList = ({ items }: PromptSuggestionListProps) => {
  return (
    <StyledPromptSuggestionList>
      { items.map((item, index) => <PromptSuggestionListItem key={index} text={item} />) }
    </StyledPromptSuggestionList>
  );
};

export default PromptSuggestionList;